$(function () {
    if (typeof SAVE_PRODUCT_AJAX_URL === 'undefined' || typeof Cookies === 'undefined') {
        return;
    }

    var cookie = 'arc_saved_products';
    var count = $('.js-saved-product-count');

    function getSavedProductIds() {
        var ids = Cookies.get(cookie);

        if (typeof ids === 'string') {
            try {
                ids = JSON.parse(ids);
            } catch (jsonSyntaxError) {
                ids = [];
            }
        }

        if (!$.isArray(ids)) {
            ids = [];
        }

        return ids;
    }

    function toggleSaveProduct(e) {
        var link = $(this);
        var productId = parseInt(link.data('save-product-id'), 10);
        var links = $('a[data-save-product-id="' + productId + '"]');
        var savedProductIds = getSavedProductIds();
        var page = $('body');
        var message = $('#save-product-message');
        var form = $('#saved-product-form form');
        var productAction = null;
        var templateParts = [];
        var index = -1;

        e.preventDefault();

        // Remove existing message.
        if (message.length !== 0) {
            message.remove();
        }

        // Find index of product in array of saved products.
        index = $.inArray(productId, savedProductIds);

        // Add or remove the product from the list.
        if (index === -1) {
            savedProductIds.push(productId);
            productAction = 'add';
        } else {
            // savedProductIds = savedProductIds.splice(index, 1);
            savedProductIds.splice(index, 1);
            productAction = 'remove';
        }

        // Save the updated list of saved products.
        Cookies.set(cookie, JSON.stringify(savedProductIds), {
            expires: 365
        });

        // List all template parts to replace.
        links.each(function (currentLinkIndex, currentLinkElement) {
            templateParts.push($(currentLinkElement).data('save-product-part'));
        });

        // Send Ajax request for replacement link and message.
        $.ajax({
            url: SAVE_PRODUCT_AJAX_URL,
            type: 'post',
            data: {
                action: 'save_product',
                product_action: productAction,
                product_id: productId,
                template_parts: templateParts
            },
            success: function (response) {
                var replacementLinks = null;
                var replacementMessage = null;

                // Convert response string to object.
                if (typeof response === 'string') {
                    try {
                        response = JSON.parse(response);
                    } catch (jsonSyntaxError) {
                        // do nothing
                    }
                }

                // Response not a valid object? Give up.
                if (!$.isPlainObject(response)) {
                    return;
                }

                // Replace links and add same event listener.
                replacementLinks = response.links;

                if ($.isPlainObject(replacementLinks)) {
                    links.each(function (relatedLinkIndex, relatedLinkElement) {
                        var relatedLink = $(relatedLinkElement);
                        var templatePart = relatedLink.data('save-product-part');
                        var replacementLink = null;

                        if (!replacementLinks.hasOwnProperty(templatePart)) {
                            return;
                        }

                        replacementLink = $(replacementLinks[templatePart]);

                        replacementLink.on('click', toggleSaveProduct);
                        relatedLink.replaceWith(replacementLink);
                    });
                }

                // Replace message.
                replacementMessage = $(response.message);

                if (replacementMessage.length !== 0) {
                    page.prepend(replacementMessage);
                }
            }
        });

        // Replace hidden form inputs (if necessary)
        if (form.length !== 0) {
            form.find('[name="saved_products[]"]').remove();

            for (var i = 0, j = savedProductIds.length; i < j; i++) {
                form.append($('<input type="hidden" name="saved_products[]" value="' + savedProductIds[i] + '">'));
            }
        }

        // Update saved product count(s)
        count.text(savedProductIds.length);
    }

    $('[data-save-product-id]').each(function (linkIndex, linkElement) {
        $(linkElement).on('click', toggleSaveProduct);
    });

    // Update saved product count(s) on page load
    count.text(getSavedProductIds().length);
});
